import { config } from '@services/config';
import { WritingCompanySearchResponse } from '@lio/api-types';
import { productOfferingQueryKey } from './keys';
import { useQuery } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';

export const useListWritingCompanies = (enabled = true) => {
  const client = useClient();
  const result = useQuery<WritingCompanySearchResponse, Error>({
    queryKey: productOfferingQueryKey.writingCompanies,
    ...config,
    queryFn: () => client.get(`writing-company`).json<WritingCompanySearchResponse>(),
    enabled,
  });
  return {
    ...result,
    writingCompanies: result.data,
  };
};
